import { render, staticRenderFns } from "./ConsentStep.vue?vue&type=template&id=3e3a15d2&"
import script from "./ConsentStep.vue?vue&type=script&lang=js&"
export * from "./ConsentStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports